<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header" style="padding-bottom: 5px !important">
                    <div >
                        <h5 class="pb-2"> نوع الانضمام</h5>

                       <span> بالرجائ ملئ جميع الحقول </span>
                    </div>
                    <ng-template >
                        
                    </ng-template>
                </div>
                <div class="card-body">
                    <form class="needs-validation" autocomplete="off" 
                    [formGroup] = "jointypeForm"
                    (ngSubmit)="onSubmit()" 
                    novalidate>
                        <div class="form-row">
                            <!-- title  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> اسم نوع الانضمام</label>
                                <input class="form-control" id="validation01" type="text" formControlName="title"
                                [tooltip]="fc.title.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.title.valid && (fc.title.touched)"
                                [class.is-invalid]="fc.title.invalid && (fc.title.touched)"
                                
                                     required
                                     placeholder="اسم نوع الانضمام"
                                    containerClass="" />
                            </div>
                    
                            <!-- order  -->
                            <div class="col-6 mb-3">
                                <label for="validation01"><span class="validation-required">*</span> العدد</label>
                                <input class="form-control" id="validation01" type="text" formControlName="order"
                                [tooltip]="fc.order.errors?.required ? 'الحقل مطلوب' : null"
                                [class.is-valid]="fc.order.valid && (fc.order.touched)"
                                [class.is-invalid]="fc.order.invalid && (fc.order.touched)"
                                onlyNumbers
                                     required
                                     placeholder="العدد"
                                    containerClass="" />
                            </div>
                        </div>

                         <!-- to insert image  -->
                         <div class="col-6 my-3 " >
                            <img  src="{{ imageLogo }}" style="width: 60%; height: 220px;" class="image-style p-2" />
                           <input type="file" formControlName="branchImage" accept="image/*" #file id="getLogo"
                            style="display: none" (change)="getLogoUrl($event)" />
                        <button type="button" onclick="document.getElementById('getLogo').click()"
                            class="btn   d-block"  style="width: 60%;">
                            ارفاق صورة
                        </button>    
                                    </div>
                            
                        
                        
                        <ng-template #elseBlock>
                            <button [disabled]="button" class="btn pull-right" type="submit">
                               حفظ
                            </button>
                            </ng-template>
                        <div *ngIf="update; else elseBlock">
                            <button class="btn pull-right" type="submit">
                                تعديل
                            </button>
                       </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

